import * as React from 'react';
import cn from 'clsx';
import { LinkButton, UIText1, IconFunctionalSuccessCircle24, Image } from '@cian/ui-kit';
import { ComponentWithInnerHTML } from '@cian/frontend-e2e-deal-component';

import { ListWithIcons } from '../../../../components/ListWithIcons';
import { IWithDeviceTypeProps, withDeviceType } from '../../../../utils/withDeviceType';
import { formatToRub } from '../../../../utils/formatToRub';
import { IDealLocation, ISettlementMethod, ITariff } from '../../../../types/promoCalculator';
import { createSrcSources } from '../../../../utils/srcSets';

import * as styles from './styles.css';

interface IDealPriceCardProps extends IWithDeviceTypeProps {
  selectedDealLocation: IDealLocation;
  selectedTariff?: ITariff;
  selectedSettlementMethod?: ISettlementMethod;
  dealFormUrl: string;
  onCreateDealButtonClick(): void;
}

const DealPriceCard: React.FC<React.PropsWithChildren<IDealPriceCardProps>> = props => {
  const {
    deviceType,
    isDesktop,
    dealFormUrl,
    selectedDealLocation,
    selectedTariff,
    selectedSettlementMethod,
    onCreateDealButtonClick,
  } = props;

  const imageSize = isDesktop ? 80 : 60;
  const cost =
    selectedDealLocation.baseCost +
    (selectedTariff?.additionalCost || 0) +
    (selectedSettlementMethod?.additionalCost || 0);

  const price = formatToRub(cost.toString());

  const infoList = [...selectedDealLocation.listView, ...(selectedSettlementMethod?.additionalListView || [])];
  const notification = selectedTariff?.notification;
  const theme = selectedTariff?.theme;

  const imageSources = createSrcSources(notification?.image);

  return (
    <div className={cn(styles['card'], theme && styles[theme], styles[deviceType])}>
      <div className={cn(styles['card-header'], styles[deviceType])}>
        <span className={styles['price']}>{price}</span>
        {notification && (
          <div className={styles['notification']}>
            <UIText1>
              <ComponentWithInnerHTML html={notification.text} />
            </UIText1>
            {notification?.image && (
              <div className={cn(styles['notification-image'], styles[deviceType])}>
                <Image width={imageSize} height={imageSize} src={notification.image.x1} sources={imageSources} />
              </div>
            )}
          </div>
        )}
      </div>
      <div className={cn(styles['list'], styles[deviceType])}>
        <ListWithIcons.List gap={12}>
          {infoList.map((listItem, i) => (
            <ListWithIcons.Item key={i} icon={<IconFunctionalSuccessCircle24 color="primary_100" />}>
              {listItem}
            </ListWithIcons.Item>
          ))}
        </ListWithIcons.List>
      </div>
      <div className={cn(styles['deal-form-button'], styles[deviceType])}>
        <LinkButton href={dealFormUrl} fullWidth size="L" onClick={onCreateDealButtonClick}>
          Провести сделку
        </LinkButton>
      </div>
    </div>
  );
};

const DealPriceCardWithDeviceType = withDeviceType(DealPriceCard);
export { DealPriceCardWithDeviceType as DealPriceCard };
